import React from 'react';
export function ProblemSection() {
  return <section className="py-16 bg-white px-4" data-id="element-231">
      <div className="max-w-3xl mx-auto text-center" data-id="element-232">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-233">
          La ciencia es clara
        </h2>
        <div className="h-1 w-20 bg-[#C4973B] mx-auto rounded-full mb-8" data-id="element-234"></div>

        <p className="text-lg text-gray-600 mb-2" data-id="element-235">
          El 70–80% de las señales entre cuerpo y cerebro viajan de abajo hacia
          arriba a través del nervio vago.
        </p>
        <p className="text-xl font-bold text-gray-900 mb-2" data-id="element-236">
          No te calmas pensando diferente.
        </p>
        <p className="text-xl font-bold text-[#C06B6B]" data-id="element-237">
          Te calmas enviando una señal corporal distinta.
        </p>
        <p className="mt-6 text-gray-500 italic" data-id="element-238">
          La seguridad no es una idea. Es una activación parasimpática medible.
          Sin ella, pensar positivo no alcanza.
        </p>
      </div>
    </section>;
}